import bridge from '@/utils/bridge';
import { getAllGroups } from '@/utils/ContactUtils';
import store from '@/store';
import ContactProxy from '@/Proxies/ContactProxy';
import { Actions } from '@/actions/restricted';
import { getCounter } from './utilities';

class AllGroupsProxy {
  counter = getCounter();

  contactProxySubscriptions = {};

  subscribedIds = {};

  constructor() {
    bridge.subscribe('/contact/new/group', this.onGroupAdded.bind(this));
    bridge.subscribe('/contact/delete/group', this.onGroupDeleted.bind(this));
  }

  getCurrentState = () => {
    const state = store.getState();
    const allGroupsContacts = state.restricted.contact.all_groups_meta_proxy;
    if (!allGroupsContacts) {
      return {};
    }

    return allGroupsContacts;
  };

  setAllGroupsInStore(ownerGuid, contactIds) {
    store.dispatch(Actions.all_groups_meta_proxy({ [ownerGuid]: contactIds }));
    this.contactProxySubscriptions[ownerGuid].update(ownerGuid, contactIds);
  }

  onGroupAdded(contact) {
    const allGroupsContacts = this.getCurrentState();
    const { ownerGuid } = contact;
    if (!allGroupsContacts[ownerGuid]) {
      return;
    }
    const groupsSet = new Set([...allGroupsContacts[ownerGuid]]);
    groupsSet.add(contact.jid);
    this.setAllGroupsInStore(ownerGuid, Array.from(groupsSet));
  }

  onGroupDeleted(contact) {
    const allGroupsContacts = this.getCurrentState();
    const { ownerGuid } = contact;
    if (!allGroupsContacts[ownerGuid]) {
      return;
    }
    const groupsSet = new Set([...allGroupsContacts[ownerGuid]]);
    groupsSet.delete(contact.jid);
    this.setAllGroupsInStore(ownerGuid, Array.from(groupsSet));
  }

  subscribe(ownerGuid) {
    const id = this.counter.next().value;

    if (!this.subscribedIds[ownerGuid]) {
      this.subscribedIds[ownerGuid] = [];
    }
    if (this.subscribedIds[ownerGuid].length === 0) {
      getAllGroups(ownerGuid).then((contacts) => {
        const contactsSet = new Set();
        for (let i = 0; i < contacts.length; i += 1) {
          contactsSet.add(contacts[i].jid);
        }
        this.setAllGroupsInStore(ownerGuid, Array.from(contactsSet));
      });
    }
    this.subscribedIds[ownerGuid].push(id);

    if (!this.contactProxySubscriptions[ownerGuid]) {
      this.contactProxySubscriptions[ownerGuid] = ContactProxy.subscribe(
        ownerGuid,
        []
      );
    }

    return { unsubscribe: this.unsubscribe.bind(this, ownerGuid, id) };
  }

  unsubscribe(ownerGuid, id) {
    if (!ownerGuid || !id) {
      return;
    }
    const subscriptions = this.subscribedIds[ownerGuid];
    if (subscriptions.length > 0) {
      const idx = subscriptions.indexOf(id);
      subscriptions.splice(idx, 1);
    }
    if (subscriptions.length < 1) {
      this.setAllGroupsInStore(ownerGuid, []);
      this.contactProxySubscriptions[ownerGuid].unsubscribe();
    }
  }
}

export default new AllGroupsProxy();
